import React from 'react';

import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { Row } from 'components/Containers/Row/Row';

import Label from 'components/form/Label/Label';
import PageLoadingMask from 'components/masks/PageLoadingMask';
import StandardAutoInsuranceOffer from 'components/Offers/StandardAutoInsuranceOffer/StandardAutoInsuranceOffer';
import StaticOfferContainer from 'partial/OfferManager/StaticOfferContainer';
import ZeroState from 'components/ZeroState/ZeroState';

const AutoInsuranceOfferView = props => {
  const { states, eventHandler } = props;
  const loading =
    states.fetching ||
    states.loadingSearchValues ||
    states.insuranceResponse === null;

  if (loading) {
    return <PageLoadingMask description={'Retrieving Offers'} />;
  } else {
    return (
      <>
        <Row className="margB8">
          <div>
            <Label type="H6 bold">{`${
              states?.insuranceResponse?.items?.length || 0
            } Results`}</Label>
          </div>
        </Row>
        <Row>
          {states?.insuranceResponse?.items?.length > 0 ? (
            <FlexContainer className="flex-wrap m-justify-between">
              <StaticOfferContainer
                eventHandler={eventHandler}
                offerMetadataList={states?.insuranceResponse?.items || null}
                pagePosition={props.moduleName}
                modulePosition={1}
                autoInsuranceTemplate={StandardAutoInsuranceOffer}
                setStatesPrefill={props.setStatesPrefill}
                enableInsurancePrefill={props.enableInsurancePrefill}
                {...props}
              />
            </FlexContainer>
          ) : (
            <ZeroState />
          )}
        </Row>
      </>
    );
  }
};

export default AutoInsuranceOfferView;
